import { render, staticRenderFns } from "./AulasConfirmadasLancadasAno.vue?vue&type=template&id=1bb425a4&scoped=true"
import script from "./AulasConfirmadasLancadasAno.vue?vue&type=script&lang=js"
export * from "./AulasConfirmadasLancadasAno.vue?vue&type=script&lang=js"
import style0 from "./AulasConfirmadasLancadasAno.vue?vue&type=style&index=0&id=1bb425a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb425a4",
  null
  
)

export default component.exports